import React from 'react'

import Grid from '../../../../components/Grid'
import TickerIcon from './TickerIcon'

import { TTickerItem } from '../../../../types/tickers'

const TickerBar: React.FC<{
  tickers: TTickerItem[]
}> = (props) => {
  return (
    <div className="text-12 font-bold bg-lightgrey-light">
      <Grid.Container>
        <Grid.Row>
          {props.tickers.map((item, index, array) => {
            const text = (item.text || '') + (item.footNoteIndicator || '')
            return (
              <Grid.Col key={index} className={`h-32 items-center ${calculateStyle(index, array)}`}>
                <TickerIcon type={item.icon} />
                {text}
              </Grid.Col>
            )
          })}
        </Grid.Row>
      </Grid.Container>
    </div>
  )
}

export const calculateStyle = (index: number, array: TTickerItem[]): string => {
  if (array.length === 2) {
    if (index === 0) {
      // left ticker
      return 'hidden sm:flex sm:justify-start'
    }
    if (index === 1) {
      // right ticker
      return 'flex justify-center sm:justify-end'
    }
  }
  if (array.length === 3) {
    if (index === 0) {
      // left ticker
      return 'hidden sm:flex sm:justify-start'
    }
    if (index === 1) {
      // center ticker
      return 'flex justify-center sm:justify-end md:justify-center'
    }
    if (index === 2) {
      // right ticket
      return 'hidden justify-end md:flex'
    }
  }
  // center ticker
  return 'flex justify-center'
}

export default TickerBar
